<template>
  <div class="content1">
    <div class="message">
      <div class="shell">
        <div class="Messagetext">
          <span class="text">【{{ showSign }}】{{ form.content }}</span>
          <div class="time">中午 12:00</div>
        </div>
      </div>
    </div>
    <el-form ref="ruleForm" :model="form" :rules="rules" label-width="160px">
      <div class="box">
        <el-form-item label="群发对象" class="fixedWidth">
          <el-radio-group v-model="form.group_type">
            <el-radio label="1">输入手机号</el-radio>
            <el-radio label="2">按会员标签</el-radio>
            <el-radio label="0">全部</el-radio>
          </el-radio-group>
          <div v-if="form.group_type.includes('1')">
            <el-input
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 4 }"
              placeholder="仅支持大陆手机号，多个手机号请换行"
              v-model="form.mobile"
              @input="numChange"
            >
            </el-input>
            <div class="textGray">
              发给<span>{{ mobileNum }}</span
              >个人
            </div>
          </div>
          <div v-if="form.group_type.includes('2')">
            <el-select
              v-model="form.tag_id"
              placeholder="请选择会员标签"
              size="small"
            >
              <el-option
                v-for="item in options"
                :key="item.id"
                :label="item.title"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
        </el-form-item>
        <el-form-item label="短信内容" class="fixedWidth">
          <div>
            <el-button type="text" @click="choseModel">选择模板</el-button>

            <el-button type="text" @click="addModel">存为新模板</el-button>
          </div>
          <div>
            <el-input
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 4 }"
              maxlength="293"
              placeholder="请输入短信内容"
              v-model="form.content"
            >
            </el-input>
          </div>
          <div>
            已输入<span>{{ showSign.length + 3 + form.content.length }}</span>
            字(含签名)，按
            <span>{{
              Math.ceil((showSign.length + 3 + form.content.length) / 70)
            }}</span>
            条短信计费
          </div>
        </el-form-item>
        <el-form-item label="短信签名">
          【{{ showSign }}】
          <el-popover
            placement="top-start"
            width="200"
            trigger="hover"
            :content="'【' + showSign + '】' + form.content"
          >
            <el-button type="text" slot="reference">预览</el-button>
          </el-popover>
          <!-- <el-button type="text">修改</el-button> -->
          <!-- （本月还能修改2次） -->
        </el-form-item>
        <el-form-item label="发送时间">
          <div>
            <el-radio v-model="send" label="0">立即发送</el-radio>
          </div>
          <div>
            <el-radio v-model="send" label="1">定时发送</el-radio>
            <el-date-picker
              v-model="sendTime"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetime"
              size="small"
              placeholder="选择日期时间"
            >
            </el-date-picker>
          </div>
        </el-form-item>
        <el-form-item>
          <el-checkbox v-model="id_agree"></el-checkbox>
          同意
          <el-button type="text">《短信服务协议》</el-button>
        </el-form-item>
        <el-form-item>
          <el-button @click="$router.go(-1)">取消</el-button>
          <el-button
            type="primary"
            @click="submit('ruleForm')"
            :disabled="!id_agree"
            >确定</el-button
          >
        </el-form-item>
      </div>
      <!-- 底部提交 -->
      <!-- <div class="bottom">
        
      </div> -->
    </el-form>

    <!-- 优惠券弹窗 -->
    <el-dialog title="模板选择" :visible.sync="dialogModule" width="750px">
      <div class="show">
        <!-- 分类 -->
        <div class="top">
          <el-button
            type="primary"
            size="mini"
            v-for="(item, index) in buttonDatas"
            :key="index"
            @click="screen(index + 1)"
          >
            {{ item }}
          </el-button>
        </div>
        <div class="list">
          <el-radio
            v-model="chooseModelId"
            :label="item.content"
            v-for="(item, index) in allModel"
            :key="index"
          >
            {{ item.content }}
          </el-radio>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="popPupChose">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import newSelectCommodityNum from "@/components/commodity/newSelectCommodityNum.vue";
import { mapGetters } from "vuex";
import {
  getSMSConfig,
  allSMSTemplate,
  smsSendGroup,
  addTemplate
} from "@/api/set";
import { allTag } from "@/api/market";
import time from "@/utils/time";
import { addAttention, editAttention, detailAttention } from "@/api/market";
export default {
  computed: {
    ...mapGetters(["token", "app_id"])
  },

  data() {
    return {
      showSign: "", //签名展示
      send: "0", //0立即发送 1定时发送
      initStatus: false,
      id_agree: false,
      dialogModule: false,
      allModel: [],
      chooseModelId: "",
      sendTime: "",
      mobileNum: 0,
      // end
      form: {
        group_type: "1", //发送人群类型 1按照手机号 2按照会员标签筛选
        mobile: "", //电话号码
        tag_id: "", //标签
        content: "", //短信内容
        send_time: "0"
      },
      buttonDatas: ["验证码", "营销短信", "通知短信", "自定义"],
      options: [],
      rules: {
        title: [{ required: true, message: "请输入活动名称", trigger: "blur" }],
        start_time: [
          { required: true, message: "请输入活动开始时间", trigger: "blur" }
        ]
      },
      // 规则一，活动层级
      // form.give_status: "0",
      // 数字转成汉字
      tranformHanzi: {}
    };
  },
  beforeMount() {
    let a = "1";
    let b = "q";
    a += b;
    console.log("数据", a);
    this.init(); //获取数据
  },
  methods: {
    screen(index) {
      let data = {
        token: this.token,
        app_id: this.app_id
      };
      if (index == 4) {
        data.self = 1;
      } else {
        data.type = index;
      }
      allSMSTemplate(data).then(res => {
        if (res.code == 200) {
          this.allModel = res.data.data;
          this.total2 = res.data.total;
        }
      });
    },
    // 彈窗模板選擇
    popPupChose() {
      this.form.content = this.chooseModelId;
      this.dialogModule = false;
    },
    // 存模板
    addModel() {
      this.$confirm("确认要存该内容为模板吗？")
        .then(_ => {
          let data = {
            token: this.token,
            app_id: this.app_id,
            content: this.form.content
          };
          addTemplate(data).then(res => {
            if (res.code == 200) {
              this.$message.success("保存成功");
            } else {
              this.$message.warning(res.msg);
            }
          });
        })
        .catch(_ => {});
    },
    //输入手机号进行处理
    numChange() {
      console.log("val数据", this.form.mobile.replace(/[\r\n]/g, ","));
      let arr = this.form.mobile.replace(/[\r\n]/g, ",").split(",");
      let newArr = arr.filter(function(item) {
        return item;
      });
      this.mobileNum = newArr.length;
      console.log(newArr);

      // if (this.textarea2.length % 12 == 0) {
      //   this.textarea2 += "";
      // }
    },
    // 选择模板
    choseModel() {
      this.dialogModule = true;
      let data = {
        token: this.token,
        app_id: this.app_id
      };
      allSMSTemplate(data).then(res => {
        if (res.code == 200) {
          this.allModel = res.data.data;
          this.total2 = res.data.total;
        }
      });
    },
    // 提交
    submit(formitem) {
      if (this.form.content == "") {
        this.$message.warning("请填写短信内容！！");
        return;
      }
      if (this.send == 1) {
        if (this.sendTime == "") {
          this.$message.warning("请填写发送时间！！");
          return;
        } else {
          this.form.send_time = this.sendTime;
        }
      } else {
        this.form.send_time = 0;
      }
      if (this.form.group_type == 0) {
        this.form.mobile = "";
        this.form.tag_id = "";
      } else if (this.form.group_type == 1) {
        this.form.tag_id = "";
      } else if (this.form.group_type == 2) {
        this.form.mobile = "";
      }
      console.log("提交之前的数据", this.form);
      this.$refs[formitem].validate(valid => {
        if (valid) {
          let data = { ...this.form };
          data.app_id = this.app_id;
          data.token = this.token;
          smsSendGroup(data).then(res => {
            if (res.code == 200) {
              this.$message.success("保存成功");
              this.$router.go(-1);
            } else {
              this.$message.warning(res.msg);
            }
            console.log("保存", res);
          });
          console.log("data", data);
        } else {
          this.$message.warning("请填写必填项！！");
        }
      });
    },
    init() {
      let data = {
        token: this.token,
        app_id: this.app_id
      };
      allTag(data).then(res => {
        console.log("allMermberTag", res);
        this.options = res.data;
      });
      getSMSConfig(data).then(res => {
        console.log("allMermberTag", res);
        this.showSign = res.data.app_name;
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.colorRed {
  color: red;
  padding: 0 6px;
}
.el-form-item {
  margin-bottom: 15px;
}
.content1 {
  border: 1px solid #f1f1f1;
  font-size: 14px;
  display: flex;
  // background: #f2f2f6;

  .message {
    width: 400px;
    .shell {
      width: 320px;
      height: 504px;
      margin: 30px auto;
      padding: 120px 20px 40px;
      border: 1px solid #f2f2f2;
      background: url("../../../../../../../public/img/bgMessage.jpg");
      .Messagetext {
        width: 100%;
        height: 100%;
        overflow: auto;
        .text {
          // min-width: 100%;
          display: inline-block;
          padding: 6px;
          border-radius: 12px;
          background: #f2f2f2;
        }
        .time {
          color: #9f9f9f;
          margin-top: 4px;
          font-size: 10px;
        }
      }
    }
  }
  // 上层
  .el-form {
    flex: 1;
    padding: 0 20px 10px 20px;
    overflow-y: auto;
    .box {
      margin-top: 20px;
      padding: 10px;
      border-radius: 6px;
      .title {
        font-weight: 550;
        padding: 10px 0px 10px 20px;
      }
      // 样式
      .fontSize14 {
        font-size: 14px;
      }
      .textAlign {
        text-align: right;
      }
      .color {
        margin: 0px 5px;
        color: #999;
        font-size: 12px;
      }
      .inputMargin {
        width: auto;
        margin: 0 6px;
      }
      .inputWidth {
        height: 30px;
        width: 130px;
      }
      .newInputWidth {
        height: 30px;
        width: 120px;
      }
      .fixedButton {
        width: 70px;
      }
      .width30 {
        width: 30px;
        font-size: 14px;
      }
      .marginBottom10 {
        margin-bottom: 20px;
      }
    }
    // 表格
    .table {
      max-width: 900px;
      border: 1px solid #fff;
      background: #fff;
      height: 100%;
      display: flex;
      border-radius: 6px;
      > div {
        padding: 20px;
      }
      .name {
        font-weight: 550;
        padding: none;
      }
      .table-left {
        width: 220px;
        border-right: 1px solid #f1f1f1;
      }
      .table-right {
        flex: 1;
        .marginBottom {
          margin-bottom: 10px;
        }
        margin-bottom: 10px;
      }
    }
  }
  // 底部
  .bottom {
    height: 60px;
    line-height: 60px;
    background: #fff;
    text-align: center;
    width: 100%;
    padding: 0 20px;
  }

  .flex {
    display: flex;
    align-items: center;
  }
  .fixedWidth {
    width: 500px;
    .line {
      text-align: center;
    }
  }
  .fixedWidth60 {
    width: 60px;
    padding-right: 6px;
  }
}
// 短信模板
.show {
  width: 100%;
  height: auto;
  .top {
    padding: 16px 0;
    border-top: 1px solid #ccc;
    border-bottom: 1px solid #ccc;
  }
  .list {
    width: 100%;
    > .el-radio {
      width: 100%;
      padding: 16px 0;
      border-bottom: 1px solid #ccc;
    }
  }
}
</style>
